const SkillsCard = (props) => {
  return (
    <div
      className="skill-card"
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in-back"
      data-aos-delay="300"
      data-aos-offset="0"
      data-aos-duration="200"
    >
      <img src={props.img} alt="skills" />
    </div>
  );
};

export default SkillsCard;
